import PhoneInput, { PhoneInputProps } from 'react-phone-input-2';

import 'react-phone-input-2/lib/style.css';
import './PhoneNumber.css';

export const PhoneNumber = (props: PhoneInputProps) => {
  return <PhoneInput {...props} />;
};
